import React from "react";
import { MessageCircle } from "lucide-react";
import { BRAND } from "../../lib/constants";

export default function WhatsAppFab() {
    return (
        <a
            href={`https://wa.me/${BRAND.whatsapp.replace("+", "")}`}
            target="_blank"
            rel="noreferrer"
            className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#1DA851] text-white w-14 h-14 grid place-items-center shadow-lg rounded-full transition-all hover:scale-105"
            aria-label="Chat on WhatsApp"
            data-testid="floating-whatsapp-button"
        >
            <MessageCircle size={24} strokeWidth={1.8} />
        </a>
    );
}
